/**
 * StatusBadge Component
 *
 * Displays project status with color-coded visual indicators
 * - draft: Amber/yellow
 * - active: Green
 * - archived: Gray
 */

import React from 'react';
import { ProjectStatus } from '../../types/project';

interface StatusBadgeProps {
  status: ProjectStatus;
  className?: string;
}

const statusStyles: Record<ProjectStatus, string> = {
  draft: 'bg-amber-100 text-amber-800 border-amber-300',
  active: 'bg-green-100 text-green-800 border-green-300',
  archived: 'bg-gray-100 text-gray-800 border-gray-300',
};

const statusLabels: Record<ProjectStatus, string> = {
  draft: 'Draft',
  active: 'Active',
  archived: 'Archived',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const styles = statusStyles[status];
  const label = statusLabels[status];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles} ${className}`}
      role="status"
      aria-label={`Status: ${label}`}
    >
      {label}
    </span>
  );
};
